/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_N5Inputs */

const en_to_yaml_ref_n5 = /** @type {(inputs: To_Yaml_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real boolean is written bare, which is how it should read back.`)
};

const ko_to_yaml_ref_n5 = /** @type {(inputs: To_Yaml_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진짜 불리언은 그대로 작성됩니다. 그렇게 읽혀야 하기 때문입니다.`)
};

const ja_to_yaml_ref_n5 = /** @type {(inputs: To_Yaml_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本物の真偽値は裸で書かれます。そう読み戻されるべきだからです。`)
};

/**
* | output |
* | --- |
* | "A real boolean is written bare, which is how it should read back." |
*
* @param {To_Yaml_Ref_N5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_n5 = /** @type {((inputs?: To_Yaml_Ref_N5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_N5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_n5(inputs)
	if (locale === "ko") return ko_to_yaml_ref_n5(inputs)
	return ja_to_yaml_ref_n5(inputs)
});